export default "__VITE_ASSET__18f987ae__"